import type { UserPermissions } from "@redotech/account-common/permissions";
import type { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import type { GlobalSearchCategory } from "@redotech/redo-views-common/global-search/global-search-category";

export type HomeRecordType =
  | "returns"
  | "claims"
  | "warranties"
  | "withdrawals";

export interface CreateAction {
  permission: UserPermissions;
  returnType: ReturnTypeEnum;
}

/**
 * Where one record type's home page gets its data. The page and its sections
 * take a list of these and never branch on `type`.
 */
export interface RecordHomeSource {
  type: HomeRecordType;
  /** Set to false to send this type back to its table without touching the others. */
  enabled: boolean;
  search: { category: GlobalSearchCategory; recordType?: ReturnTypeEnum };
  allHref: string;
  create?: CreateAction;
}

/**
 * Empty until the per-type sources land, when it becomes
 * `satisfies Record<HomeRecordType, RecordHomeSource>`. A type with no entry
 * keeps redirecting to its table even with the flag on.
 */
export const HOME_SOURCES: Partial<Record<HomeRecordType, RecordHomeSource>> =
  {};
